import { Injectable } from "@angular/core";
import { setBuyerSeen, SetBuyerSeenVariables, setSellerSeen, SetSellerSeenVariables } from "@dataconnect/account";
import { Store } from "@ngrx/store";
import { uiErrorCatcher } from "../helper/error.handling";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FlagInteractionVariables } from "../../../globalTypes/interactions.types";
import { httpsCallable } from "firebase/functions";
import { Functions } from "@angular/fire/functions";
import { onCallFunctions } from "../../../globalTypes/backend.api.types";
import { sleep } from "../../../globalTypes/_helpers";

@Injectable({
  providedIn: 'root'
})
export class InteractionsService {

  constructor(
    private store: Store,
    private snackBar: MatSnackBar,
    private functions: Functions,
  ) { }

  async markInteractionsAsSeen(interactionIds: string[], locationId: string, userType: "Buyer" | "Seller" ): Promise<void> {
    // TODO implement marking interactions as seen
    if(interactionIds.length === 0) return;
    if(userType === "Seller"){
      const vars: SetSellerSeenVariables = { interactionIds, locationId }
    await sleep(1000);
      await uiErrorCatcher(setSellerSeen(vars), this.snackBar, "Error marking seller interactions as seen");
    } else {
      const vars: SetBuyerSeenVariables = { interactionIds, locationId }
    await sleep(1000);
      await uiErrorCatcher(setBuyerSeen(vars), this.snackBar, "Error marking buyer interactions as seen");
    }
    // update FB interaction number
    const flagInteractionVars: FlagInteractionVariables = {
      idempotencyKey: `mark_interactions_seen_${interactionIds.join("_")}`,
      locationIds: [ locationId ]
    };
    const callable = httpsCallable(this.functions,  onCallFunctions.flagInteractionCall);
    await callable(flagInteractionVars);
  }
}